import { ChangeDetectionStrategy, Component, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RadioState } from '@app/core/states/radio.state';
import { BacsState } from '@app/library/states/bacs.state';
import { TrackMoveRequest, TrackMoveSuccess } from '@app/library/states/tracks.actions';
import { Actions, ofActionDispatched, Select, Store } from '@ngxs/store';
import { CloseCurrentPanel } from '@radioking/shared/pannel-manager';
import { SugestionInput } from '@radioking/ui/input';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-mob-move-track-modal',
  templateUrl: './mob-move-track-modal.component.html',
  styleUrls: ['./mob-move-track-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobMoveTrackModalComponent {
  @Select(RadioState.currentRadioId)
  currentRadioId$: Observable<number>;

  @Select(BacsState.allUnlockedBoxesForSelect)
  boxes$: Observable<SugestionInput[]>;

  $touched = signal(-1);

  constructor(
    private readonly dialogRef: MatDialogRef<MobMoveTrackModalComponent>,
    private readonly dialog: MatDialog,
    private readonly store: Store,
    private readonly actions$: Actions,
    @Inject(MAT_DIALOG_DATA) public dataIn: { trackId: number; boxId: number },
  ) {
    this.actions$.pipe(ofActionDispatched(TrackMoveSuccess)).subscribe(() => {
      this.dialog.closeAll();
      this.store.dispatch(new CloseCurrentPanel());
    });
  }

  onTouch(index: number) {
    setTimeout(() => {
      this.$touched.set(index);
    }, 50);
  }

  onTouchEnd() {
    this.$touched.set(-1);
  }

  clickBox(id: number) {
    const targetBac = this.store.selectSnapshot(BacsState.bacById)(id);
    this.store.dispatch(new TrackMoveRequest([this.dataIn.trackId], targetBac));
  }

  exitPanel() {
    this.dialogRef.close();
  }
}
